// TODO use /list instead of /view and group the call together

/**
 * Data already fetched from API is stored inside "requestCache" object
 */
const requestCache = {};

/**
 * Fetch API data
 *
 * @param {Object} params {module, id, fields}
 * @returns {Promise} Promise returns the requested item
 */
const getData = ({
    module,
    id,
    fields
}) => {
    const serializedRequestKey = JSON.stringify({
        module,
        id,
        fields
    });
    if (!requestCache[serializedRequestKey]) {
        return requestCache[serializedRequestKey] = new Promise(function (resolve, reject) {
            $.post(`${window._dynamic_base}/view/${window.websiteID}`, {
                module: module,
                id: id,
                fields: fields
            }).then(response => {
                resolve(response);
            });
        })
    }
    return requestCache[serializedRequestKey];
}

export default container => {
    $('.js-module-dynamic', container).not('.js-module-dynamic--value').each(function () {
        const $el = $(this);
        const module = $el.data('module');
        const id = $el.data('id');
        const fields = []; // list of fields we want to request

        const $rate = $el.find('.js-dynamic-rate');

        if ($rate.length) {
            fields.push('rate');
        }

        if (module && id && fields.length) {
            getData({
                module: module,
                id: id,
                fields: fields
            }).then(response => {
                if (response.rate) $rate.find('.js-dynamic-rate-value').html(response.rate)
                else $rate.hide();

                $el.addClass('js-module-dynamic--value');
            })
        }
    });
}